export enum RemedialType {
    DAMAGED = 1,
    INCORRECT = 2,
    MISSING = 3
}
